<!--
출고요청 작업
-->
<template>
    <div class="">
        <!-- 작업건수 -->
        <div class="uk-text-right">
            <span class="uk-text-large">REMAINING WORKS :</span>
            <span class="uk-text-primary uk-text-large3">{{ items.length }}</span>
        </div>

        <div uk-grid class="uk-grid-small">
            <div class="uk-width-auto">
                <!-- 선택 일괄기능 -->
                <app-batch-controller :batch="batch" hide-none-checked>
                    <app-batch-job-shipout-request
                            slot="jobs"
                            :batch="batch"
                            :csrf-token="csrfToken"
                            :region-id="regionId"
                    ></app-batch-job-shipout-request>
                </app-batch-controller>
            </div>
            
            <div class="uk-width-expand">

                <!-- 스캔 -->
                <div class="uk-card uk-card-default uk-card-large uk-margin-bottom" v-on:click="focusScanInput">
                    <div class="uk-card-body">
                        <p v-show="! scanned_msg" class="uk-text-center uk-text-primary uk-text-large3" >
                            출고요청 BOX에 운송장 부착 후 스캔하세요<br />
                            <span class="uk-text-muted uk-text-large">
                                (출고보류가 해지됩니다)
                            </span>
                        </p>
                        
                        <p v-show="scanned_msg" class="uk-text-center uk-text-large3" :class="msgClass" >
                            {{ scanned_msg }}<br />
                            <span class="uk-text-muted">
                                SCANNED : {{ scanned_val }}
                            </span>
                        </p>
                        

                        <!-- 스캔 폼 -->
                        
                        <input 
                            class="uk-input uk-width-1-1 uk-form-large"  
                            placeholder="SHIPPING LABEL SCAN"
                            id="scan"
                            v-model.trim="scan"
                            v-on:keyup.enter="scanAjax"
                            
                        />
                        
                    </div>
                </div>
            </div>

            
        </div>
        


        


        <!-- empty 표시 -->
        <div v-if="items.length === 0" class="uk-card uk-card-default uk-card-body uk-margin-bottom">
            <div class="uk-placeholder uk-text-center uk-text-muted uk-text-large">
                EMPTY
            </div>
        </div>

        

        <!-- 전체선택 -->
        <div v-if="items.length > 0" style="padding: 20px;">
            <label class="">
                <app-batch-all-item-checker :items="batch.items" style="width: 26px; height: 26px; margin-right: 5px"></app-batch-all-item-checker>
                SELECT TO PRINT (선택하면 작업내역을 출력할 수 있습니다)
            </label>
        </div>
        

        <!-- 리스트 -->
        <div 
            class="uk-card uk-card-default uk-card-small uk-card-hover uk-margin-bottom"
            v-for="(item, index) in items"
            :key="index"
        >
            <div class="uk-card-header uk-grid-small" uk-grid>

                <div class="uk-width-auto">
                    <app-batch-item-checker :item="item.checkbox" style="width: 26px; height: 26px; margin-top: 6px"></app-batch-item-checker>
                </div>
                
                <div class="uk-width-expand uk-flex uk-flex-left">

                    <!-- 지연일 -->
                    <div v-if="item.delay_days_from_req_at > 0" class="uk-margin-large-right">
                        <i class="uk-text-large uk-text-danger uk-text-middle">{{ item.delay_msg }}</i>
                    </div>

                    <!-- 배송번호 -->
                    <div class="uk-text-large uk-margin-large-right" title="배송번호">
                        <span uk-icon="icon: hashtag; ratio: 1" class="uk-text-middle"></span>
                        <span class="uk-text-middle">{{ item.h_code }}</span>
                    </div>

                    <!-- 수취인 -->
                    <div class="font-size-2rem uk-margin-large-right" title="수취인">
                        <i class="material-icons font-size-2d5rem">person</i>
                        <span class="uk-text-middle">{{ item.h_name }}</span>
                    </div>

                    <!-- 회원사 -->
                    <div class="uk-text-large uk-margin-large-right" title="회원사" v-if="hasGeneral">
                        <i class="material-icons">home</i>
                        <span class="uk-text-middle">{{ item.h_user_nick }}</span>
                    </div>

                    <!-- 회원사서함 -->
                    <div class="uk-text-large uk-margin-large-right" title="회원사서함">
                        <i class="material-icons">mail</i>
                        <span class="uk-text-middle">{{ item.h_user_mailbox }}</span>
                    </div>

                    
                </div>

                <!-- 상세버튼 -->
                <div class="uk-width-auto">
                    <button
                        class="uk-button uk-button-default uk-button-small"
                        onclick="$.app.on_event.move(arguments);"
                        :data-url="'/prods/'+item.first_prod_id"
                        data-target="_blank"
                    ><span uk-icon="link"></span> 상품상세</button>
                </div>

            </div>
            <div class="uk-card-body uk-flex uk-flex-around">


                <!-- 보관장소 -->
                <div class="uk-text-center">
                    <div class="uk-text-small">
                        <span uk-icon="info"></span>
                        보관장소
                    </div>
                    <div class="uk-text-large uk-text-primary">
                        {{ item.h_storage }}
                    </div>
                </div>

                <!-- 송장 -->
                <div class="uk-text-center">
                    <div class="uk-text-small">
                        <span uk-icon="info"></span>
                        운송장번호
                    </div>
                    <div class="font-size-2rem uk-text-primary">
                        {{ item.h_blno }}
                    </div>
                </div>

                <!-- hawb -->
                <div v-if="item.h_blno !== item.h_hawb" class="uk-text-center">
                    <div class="uk-text-small">
                        <span uk-icon="info"></span>
                        HAWB
                    </div>
                    <div class="uk-text-large">
                        {{ item.h_hawb }}
                    </div>
                </div>

                <!-- 패키지수 -->
                <div class="uk-text-center">
                    <div class="uk-text-small">
                        <span uk-icon="info"></span>
                        패키지 수
                    </div>
                    <div class="uk-text-large">
                        {{ item.h_package_amount }}
                    </div>
                </div>
            </div>


            <div class="uk-card-footer uk-text-right">
                <!-- 실패버튼 -->
                <button
                        class="uk-button uk-button-small uk-button-g-w-lg uk-button-on-r-w-r"
                        type="button"

                        v-on:click="failRequest(item)"
                >
                    <span uk-icon="'ratio: 1; icon: close"></span>
                    <span class="uk-text-middle">FAIL (출고실패)</span>
                </button>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            /**
             * 라라벨 csrf 토큰
             */
            csrfToken: {
                type: String,
                default: null,
            },
            /**
             * 출고요청정보
             */
            items: {
                type: Array,
                default: [],
            },
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },
            /**
             * 총괄권한
             */
            hasGeneral: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            // batch items 생성 (전체선택에 사용할 일괄정보 객체)
            let batch_items = [];
            _.forEach(this.items, function (item) {
                let obj = {
                    id: item.id,
                    checked: false,

                    h_code: item.h_code,
                    house_id: item.house_id,
                    h_name: item.h_name,
                    first_prod_id: item.first_prod_id,
                    h_blno: item.h_blno,
                    h_hawb: item.h_hawb,
                    h_storage: item.h_storage,
                    h_package_amount: item.h_package_amount,
                };
                item.checkbox = obj;
                batch_items.push(obj);
            });
            return {
                // 스캔 입력값
                scan: null,
                // 스캔결과 - 메세지
                scanned_msg: null,
                // 스캔결과 - 성공여부
                scanned_is_succ: false,
                // 스캔결과 - 스캔된 번호
                scanned_val: '',


                // 전체선택에 사용할 일괄정보 객체
                batch: {
                    items: batch_items,
                    checked_item_count: 0,
                    item_checked_msg_format: 'checked :count items',
                    item_checked_nothing_msg: 'No item selected',
                },
            };
        },
        computed: {
            /**
             * 스캔 결과메세지 class
             */
           msgClass: function () {
               return this.scanned_is_succ ? 'uk-text-primary' : 'uk-text-danger';
           }
        },
        watch: {
        },
        mounted: function () {

        },
        methods: {

            /**
             * 실패처리
             */
            failRequest: function (item) {
                let cmp = this;

                // 데이터 세팅
                var $modal = $('#modal-fail');

                $modal.find('.house-code').text(item.h_code);
                $modal.find('.house-name').text(item.h_name);

                // action 설정
                $modal.find('form').prop('action', '/houses/'+item.house_id+'/shipout-requests/'+item.id+'/fail');

                // 팝
                UIkit.modal($modal).show();

            },
            /**
             * 스캔 ajax 처리
             */
            scanAjax: function () {
                let cmp = this;

                // 값이 있는지 검증
                if (! cmp.scan) {
                    cmp.setScannedError('NO SCANNED');
                    return;
                }

                // ajax 옵션
                let opts = {
                    type: 'patch',
                    url: '/regions/'+cmp.regionId+'/shipout-requests/scan',
                    data: {
                        '_token': cmp.csrfToken,
                        'scan': cmp.scan
                    },
                    success: function (response, textStatus, jqXHR) {
                        // 성공
                        //console.log('success : '+response.id);
                        cmp.setScannedSucc('SUCCESS !');
                        
                        // 아이템 제거
                        _.remove(cmp.items, function (item) {
                            return item.id === response.id;
                        });
                    },
                    alert_error_msg: function(msg){
                        // 오류
                        //console.log('error : '+msg);
                        cmp.setScannedError(msg);
                        
                    },
                    complete: function(jqXHR, textStatus){

                        // 텍스트 초기화
                        cmp.scan = '';
                        cmp.focusScanInput();

                    }
                };

                // ajax 실행
                $.app.ajax.module.default(opts);

            },

            /**
             * 스캔 input 포커싱
             */
            focusScanInput: function () {
                $('#scan').focus()
            },

            /**
             * 스캔 결과작성
             */
            setScannedSucc: function (msg) {
                this.scanned_msg = msg;
                this.scanned_val = this.scan;
                this.scanned_is_succ = true;
            },
            /**
             * 스캔 결과작성
             */
            setScannedError: function (msg) {
                this.scanned_msg = msg;
                this.scanned_val = this.scan;
                this.scanned_is_succ = false;
            },

        }
    }
</script>

<style lang="scss" scoped>
</style>